import { axiosInstance } from "./BaseService";

export async function fetchDataIntegration() {
  try {
    const response = await axiosInstance.get('/data-integration');
    return response.data;
  } catch (err) {
    throw err;
  }
};
